export const DELETE_CART = "DELETE_CART";
export const GET_CART = "GET_CART";
export const ADD_TO_CART = "ADD_TO_CART";
export const DECREASE_ITEM = "DECREASE_ITEM";
export const DELETE_FROM_CART = "DELETE_FROM_CART";
export const SET_IS_LOADING_CART = "SET_IS_LOADING_CART";
export const SYNC_CART = "SYNC_CART";

/// ////////////////////////// LS /////////////////////////////////////

export const GET_CART_LS = "GET_CART_LS";
export const ADD_TO_LS = "ADD_TO_LS";
export const DECREASE_FROM_LS = "DECREASE_FROM_LS";
export const DELETE_FROM_LS = "DELETE_FROM_LS";

